<template>
  <div class="bg-[#19283F] p-8 rounded-lg">
    <div class="mx-auto sm:mx-24">
      <div class="mt-6 mb-4">
        <div class="font-medium text-xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl text-white text-center mb-11">
          ผลการคำนวณเงินกู้
        </div>
        <div
          class="font-light text-white text-start sm:text-start md:text-start lg:text-start xl:text-start
          text-base sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl mb-8">
          ยอดผ่อนชำระต่อเดือน
        </div>
        <div class="flex justify-between">
          <div></div>
          <div
            class=" text-white font-semibold text-base sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl mt-4 mb-4">
            {{ installment | showPrice }}
          </div>
          <p class="font-light text-white text-xs sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl mt-7">
            บาท
          </p>
        </div>
        <hr class="w-full">
      </div>
      <div class="font-light text-base sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl text-white mt-12 mb-8">
        วงเงินกู้สูงสุด
      </div>
      <div class="flex justify-between">
        <div></div>
        <div class="text-white font-semibold text-base sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl mt-4 mb-4">
          {{ amountLoan | showPrice }}
        </div>
        <p class="font-light text-xs sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl  text-white mt-7">
          บาท
        </p>
      </div>
      <hr class="w-full">
      <div class="font-light text-base sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl text-white mt-12 mb-8">
        รายได้รวมขั้นต่ำของผู้กู้ร่วม
      </div>
      <div class="flex justify-between">
        <div></div>
        <div class="text-white font-semibold text-base sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl mt-4 mb-4 justify-center">
          {{ revenue | showPrice }}
        </div>
        <p class="font-light text-xs sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl l text-white mt-7">
          บาท
        </p>
      </div>
      <hr class="w-full">
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstallmentResult',
  props: {
    installment: {
      type: Number,
      default: null
    },
    revenue: {
      type: Number,
      default: null
    },
    amountLoan: {
      type: Number,
      default: null
    }
  }
}
</script>
